import API_URLS from '../../constants/api-urls';
import axios from '../../utils/axios';

export type AuthenticateResponse = {
    access_token: string;
    oauth_user_id?: number | string;
};

export type AuthenticateParams = {
    client_id?: string;
    grant_type?: string;
    scopes?: string[];
    platform?: string;
    username?: string;
    password?: string;
    facebook_access_token?: string;
    identityToken?: string;
    firstName?: string;
    lastName?: string;
};

export const authenticate = (
    params: AuthenticateParams,
    headers?: Record<string, string>
): Promise<AuthenticateResponse> =>
    axios.post<AuthenticateResponse>(
        API_URLS.AUTHENTICATE,
        {
            scopes: ['full'],
            ...params
        },
        { headers }
    );
